t = require('views/internal/teacup-with-helpers')('member_cards_filter')

filters = [
  'active-day'
  'active-week'
  'active-month'
  'active-year'
  'all'
]

module.exports = t.renderable ({ filter }) ->
  t.ul '.pop-over-list.checkable', ->
    filters.forEach (filterOption) ->
      t.li { class: t.classify('active': filterOption == filter) }, ->
        t.a '.highlight-icon.js-set-filter', { href: '#', 'data-filter': filterOption }, ->
          t.check filterOption == filter, ['filter-description', filterOption]




// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_cards_filter.coffee